<template>
<div class="s4s-page">
  <div v-if="couponList.length > 0" style="padding:10px 15px">
    <div v-for="(item, index) in couponList" :key="index" class="coupon-container">
      <div :class="item.grey? 'coupon flex coupon-grey': 'coupon flex'">
        <div class="coupon-price blue">
          ¥ <span style="font-size:35px;"> {{item.Amount/100}}</span>
        </div>
        <div class="flex-1">
          <div class="coupon-title">{{item.Name}}</div>
          <div class="coupon-text grey">适用范围：{{item.content}}</div>
          <div class="coupon-text grey">有效日期：{{item.valid}}</div>
        </div>
      </div>
      <div class="coupon-help flex" @click="handleChangeHelp(index)">
        <div class="black flex-1 coupon-help-text" :style="index ==  showHelpIndex?'max-height:300px;':'max-height:21px;white-space: nowrap;'" >
          <div class="black" ><span class="grey">获取时间：</span>{{item.GrantTime}}</div>
          <div class="black" ><span class="grey">使用说明：</span>{{item.UseDescribe}}</div>
        </div>
        <div class="arrow-box " style="margin-left:5px;margin-top:-2px;" >
          <div :class="index ==  showHelpIndex?' top arrow-box-bottom':'top'"><div class="top-arrow1"></div><div class="top-arrow2"></div></div>
        </div>
      </div>
      <!-- <div class="grey coupon-phone" >限制 {{item.Tel}} 手机号使用</div> -->
      <div v-if="item.Status===3" class="coupon-status-icon">已使用</div>
      <div v-if="item.Status===4" class="coupon-status-icon">已失效</div>
      <div v-if="item.Status===5" class="coupon-status-icon">已作废</div>
      <!-- <button v-if="item.Status===2" type="default" class="coupon-status-btn sm-btn" @click="defaultTap(item.id)">立即使用</button> -->
      <div v-if="item.Status===2" :class="globalCouponId == item.id ? 'btn-checked': 'btn-unchecked'" @click="defaultTap(item.id)"></div>
      <div  v-if="item.Status===1"  class="coupon-status-text">未到有效期</div>
    </div>
  </div>
  <div v-if="couponList.length == 0" class="s4s-empty">
    <img src="https://app.s4s.cn/razio/coupon_empty.png" mode="widthFix"/>
    <span>暂无优惠券</span>
  </div>
  <div v-if="couponList2.length > 0" class="s4s-ad-header"> <div class="s4s-ad-line"></div><div class="s4s-ad-header-content">不可用优惠券</div>  <div class="s4s-ad-line"></div></div>
  <div v-if="couponList2.length > 0" style="padding:10px 15px">
    <div v-for="(item, index) in couponList2" :key="index" class="coupon-container coupon-grey">
      <div class="coupon flex">
        <div class="coupon-price blue">
          ¥ <span style="font-size:35px;"> {{item.Amount/100}}</span>
        </div>
        <div class="flex-1">
          <div class="coupon-title">{{item.Name}}</div>
          <div class="coupon-text grey">适用范围：{{item.content}}</div>
          <div class="coupon-text grey">有效日期：{{item.valid}}</div>
        </div>
      </div>
      <div class="coupon-help flex" @click="handleChangeHelp2(index)">
        <div class="black flex-1 coupon-help-text" :style="index ==  showHelpIndex2?'max-height:300px;':'max-height:21px;white-space: nowrap;'" >
          <div class="black" ><span class="grey">获取时间：</span>{{item.GrantTime}}</div>
          <div class="black" ><span class="grey">使用说明：</span>{{item.UseDescribe}}</div>
        </div>
        <div class="arrow-box " style="margin-left:5px;margin-top:-2px;" >
          <div :class="index ==  showHelpIndex2?'top arrow-box-bottom':'top'"><div class="top-arrow1"></div><div class="top-arrow2"></div></div>
        </div>
      </div>
      <div v-if="item.Status===3" class="coupon-status-icon">已使用</div>
      <div v-if="item.Status===4" class="coupon-status-icon">已失效</div>
      <div v-if="item.Status===5" class="coupon-status-icon">已作废</div>
      <div  v-if="item.Status===1"  class="coupon-status-text">未到有效期</div>
    </div>
  </div>
</div>
</template>
<script>
import advertisingShow from './../utils/advertising';

export default {
  name: 'couponNow',
  data() {
    return {
      couponList: [],
      couponList2:[],
      showHelpIndex: 0,
      showHelpIndex2: 0,
      globalCouponId: '',
      advertisingShow: advertisingShow(),
    };
  },
  activated(){
    this.globalCouponId = this.$store.getters.couponId;
    this.getCouponList(0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  mounted() {
    console.log(this.$route,'-----');
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色
        navBackgroundColor:'0x8FFFFFFF',
        appletStyle: 'black', //可选，black-黑色主题，white-白色主题
        backBtnVisible: '1', // 可选，左侧返回按钮是否显示。'0'不显示，'1'显示，不传或空则默认显示
        appletTitleBarVisible: '1',// 可选，标题栏是否显示。'0'不显示，'1'显示，默认显示
      })
      upsdk.setNavigationBarTitle({
        title: '我的优惠券'
      });
    }

  },
  methods: {
    getCouponList(status) {
      const data = this.$store.getters.coupondata
      if (data && data.Unusable && data.Unusable.length) {
          let couponList2 = data.Unusable.map(item => {
            let valid = ''
            if(item.ValidTy==1){
              valid = item.GrantTime.split(' ')[0]+'~'+item.OutTime.split(' ')[0]
            }else {
              valid = item.ValidBegin.split(' ')[0]+'~'+item.ValidEnd.split(' ')[0]
            }
            return {
              ...item,
              content: this.getContent(item.Apply),
              valid,
              grey: 'coupon-grey'
            }
          })
        this.couponList2 = couponList2
      }
      if (data && data.Usable && data.Usable.length) {
          let couponList = data.Usable.map(item => {
            let valid = ''
            if(item.ValidTy==1){
              valid = item.GrantTime.split(' ')[0]+'~'+item.OutTime.split(' ')[0]
            }else {
              valid = item.ValidBegin.split(' ')[0]+'~'+item.ValidEnd.split(' ')[0]
            }
            return {
              ...item,
              content: this.getContent(item.Apply),
              valid
            }
          })
        this.couponList = couponList;
      }
    },
    defaultTap(id) {
      console.log(id)
      this.$store.commit('SET_COUPONDID', id);
      this.$router.go(-1);
    },
    handleChangeHelp(index){
      this.showHelpIndex = this.showHelpIndex==index ? null: index
    },
    handleChangeHelp2(index){
      this.showHelpIndex2 = this.showHelpIndex2==index ? null: index
    },
    getContent(i) {
      switch (i) {
        case 1:
          return '现场单'
        case 2:
          return '电子眼'
        case 3:
          return '现场单、电子眼'
        case 4:
          return '年检代办'
        case 8:
          return '维保查询'
        case 16:
          return '码上挪车'
        default: 
          return '部分商品使用'
      }
    },
  },
  watch: {

  },
};
</script>
<style lang="scss" scoped="" type="text/css">
.s4s-page {
  font-size: 14px;
  padding: 0;
}

.s4s-tab {
  height: 45px;
  background: #fff;
  font-size: 13px;
  line-height: 42px;
  display: flex;
  border-radius: 7px 7px 0 0;
  justify-content: space-around;
  padding: 0 10px;
}

.s4s-tab-cur {
  border-bottom: 3px #3A82FF solid;
  color: #24252d;
  font-weight: bold;
}

.s4s-tab-item {
  margin: 0 10px;
  line-height: 1rem;
  font-size: .32rem;
  text-align: center;
  color: #5b5e6a;
  position: relative;
}

.coupon-container {
  box-shadow: 0 2px 4px #efefef;
  position: relative;
  overflow: hidden;
  border-radius: 2px;
  margin-top: 10px;
  background-color:#fff;
}
.coupon-container:first-child{
  margin-top: 0;
}

.coupon {
  padding: 15px 10px 10px;
  background-color: #fff;
}

.coupon-price {
  min-width: 6em;
  text-align: center;
  margin: auto auto;
}

.coupon-text {
  font-size: 12px;
  margin-top: 8px;
}
.coupon-title {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 10em;
  white-space: nowrap;
}
.coupon-phone {
  background-color: #F8FBFF;
  padding: 10px 23px;
}

.coupon-container::after, .coupon-container::before {
  content: "";
  position: absolute;
  height: 10px;
  width: 10px;
  background-color: #f8f8f8;
  z-index: 2;
  left: 0;
  bottom: 31px;
  border-radius: 50px;
  margin-left: -5px;
}

.coupon-container::before {
  right: 0;
  left: auto;
  margin-right: -5px;
}
.coupon-status-icon {
  border: 1px solid #3A82FF;
  height: 70px;
  width: 70px;
  position: absolute;
  right: 11px;
  top: -20px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3A82FF;
  font-size: 13px;
  transform: rotate(-30deg);
}

.coupon-status-icon:before {
  content: "";
  display: block;
  border: 1px dashed #3A82FF;
  position: absolute;
  left: 5px;right: 5px;top: 5px;bottom: 5px;
  border-radius: 100px;
}

.coupon-status-text {
  position: absolute;
  right: 11px;
  top: 13px;
  color: #3A82FF;
  font-size: 13px;
}

.coupon-status-btn {
  position: absolute;
  right: 11px;
  top: 11px;
  box-shadow: 0 5px 15px 0 #eaeaea;
  border-radius: 200px;
  color: #FFFFFF;
  height: auto;
  font-size: 14px;
  line-height: 1.2;
  padding: 6px 18px;
  border: none;
  background-image: linear-gradient(151deg, #537EFF 0%, #105FF8 100%);
}
.coupon-container.coupon-grey .coupon-price,
.coupon-container.coupon-grey .coupon-price span,
.coupon-container.coupon-grey .coupon-title,
.coupon-container.coupon-grey .coupon-text {
  color:#9C9EA8 !important;
}
.s4s-empty img{
  width: 150px;
}
.btn-checked, .btn-unchecked{
  position: absolute;
  right: 14px;
  top: 14px;
  height: 22px;
  width: 22px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
}
.btn-checked{
  background-image: url(https://app.s4s.cn/razio/btnChecked.png);
}
.btn-unchecked{
  background-image: url(https://app.s4s.cn/razio/btnUnchecked.png);
}
.coupon-help {
  padding: 10px 8px;
  line-height: 1.5;
  border-top:1px solid #efefef;
  margin: 0 15px;
}
.coupon-help-text {
  line-height:1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  transition: all 300ms ease;
}
.arrow-box {
  transform: scale(0.7);
}
.arrow-box-bottom {
  transform: rotateZ(180deg);
  transform-origin: 50% 70%;
}
.arrow-box{
  width:16px;
  height:16px;
  position:relative;
  display: inline-block;
}
.top{
  position:absolute;
  left:0;
  top:0;
  right: 0;
  bottom: 0;
  z-index: 2;/*兼容ie8-*/
  transition: all 300ms ease;
}
.top-arrow1,.top-arrow2{
  width:0;
  height:0;
  display:block;
  position:absolute;
  left:0;
  top:0;
  z-index: 5;/*兼容ie8-*/
  border-top:8px transparent dashed;
  border-left:8px transparent dashed;
  border-right:8px transparent dashed;
  border-bottom:8px white solid;
  overflow:hidden;
}
.top-arrow1{
  border-bottom:8px #9C9EA8 solid;
}
.top-arrow2{
  top:1px;/*重要*/
  border-bottom:8px white solid;
}
</style>
